import { TikTokTrack } from 'src/Types/tracks'
import { getTimeByDuration } from 'src/Helpers/layoutHelpers'
import { SpotifyTrack } from 'src/Redux/spotifyTracksApi'

import { SearchedTrack } from './Components/TrackSearch'

export const mapSpotifyTrack = (
  track: TikTokTrack | SpotifyTrack,
): SearchedTrack => {
  const typedTrack = track as SpotifyTrack
  return {
    id: String(typedTrack.id),
    name: typedTrack.trackName,
    artistName: typedTrack.trackAuthor,
    trackCoverUrl: typedTrack.trackImage,
    previewUrl: typedTrack.previewUrl,
    trackDuration: getTimeByDuration((typedTrack?.trackDuration || 0) / 1000),
    resourceSpotifyUrl: typedTrack.resourceSpotifyUrl,
    ownerSpotifyUrl: typedTrack.artistSpotifyId,
  }
}

export const mapTikTokTrack = (
  track: TikTokTrack | SpotifyTrack,
): SearchedTrack => {
  const typedTrack = track as TikTokTrack
  return {
    id: typedTrack.trackTiktokId,
    name: typedTrack.trackTitle,
    artistName: typedTrack.trackAuthorName,
    trackCoverUrl: typedTrack.trackCoverUrl,
    previewUrl: typedTrack.trackPlayUrl,
    trackDuration: getTimeByDuration(typedTrack.trackDuration),
  }
}
